import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import i18n from "./lang/index"
import "./utils/rem.js"

Vue.config.productionTip = false

const currentDomain = window.location.hostname
if (currentDomain === 'bbee.91act.com') {
  window.location.href = "https://bbeex.91act.com"
} else {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount("#app")
}
